import React from 'react';
import { StyledContainer, StyledFormMessage, StyledInput, StyledLabel, StyledPill } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const ToggleSwitch = ({ id, label, name, value, className, onChange, disabled, onClick, checked, hint, defaultChecked, labelPosition = 'trailing', margin, ...rest }) => {
    const hintId = `${id}__hint`;
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledContainer, { className: className, margin: margin, ...dataProps },
        React.createElement(StyledLabel, { disabled: disabled, labelPosition: labelPosition },
            React.createElement(StyledInput, { id: id, type: "checkbox", name: name, value: value, onChange: onChange, onClick: onClick, disabled: disabled, checked: checked, defaultChecked: defaultChecked, ...a11yProps, "aria-describedby": ariaDescribedBy }),
            labelPosition === 'leading' && label,
            React.createElement(StyledPill, null),
            labelPosition === 'trailing' && label),
        hint && (React.createElement(StyledFormMessage, { text: hint, variant: "hint", id: hintId, labelPosition: labelPosition }))));
};
//# sourceMappingURL=index.js.map